export const SimpleFooter = () => {
  return (
    <div className="bg-neutral-background-low py-10 w-full flex justify-center">
      <div className={'w-full container-xlarge container-padding-medium text-neutral-foreground-lowest'}>
        <div className="caption-medium-semibold mb-normal-small">지엔터프라이즈 주식회사</div>
        <div className="caption-small-regular">대표&nbsp;&nbsp;이성봉</div>
        <div className="caption-small-regular">사업자번호&nbsp;&nbsp;236-88-00397</div>
        <div className="caption-small-regular">통신판매업신고&nbsp;&nbsp;제2016-서울강남-04379호</div>
        <div className="caption-small-regular mb-normal-small">서울특별시 강남구 테헤란로 507, 9층</div>
        <div className="caption-small-regular">Copyright &copy; Z Enterprise, Inc. All rights reserved.</div>
      </div>
    </div>
  );
};
